module.exports = __webpack_public_path__ + "img/hzhb.ff36668c.png";